import Place, { Place_Source } from "./Place";
import { API_BASE_URL } from "../Common/Common";

export default class GoogleSearch {
  constructor() {
    this.places = [];
  }

  //https://www.googleapis.com/customsearch/v1?key=REDACTED&searchType=image&cx=14c575c2602954647&q=riva%20ligure&start=1

  static searchImages = (title, callback, place_id) => {
    const gsrsearch = title.replace(/ /g, "%20");
    var url = `https://www.googleapis.com/customsearch/v1?key=${process.env.REACT_APP_GOOGLE_CUSTOM_SEARCH_KEY}&searchType=image&cx=${process.env.REACT_APP_GOOGLE_SEARCH_CX}&q=${gsrsearch}&start=1`;

    //var url = `https://www.googleapis.com/customsearch/v1?key=REDACTED&searchType=image&cx=14c575c2602954647&q=${gsrsearch}&start=1`;

    //const url = `${API_BASE_URL}/wikimedia_get_images.php?gsrsearch=${gsrsearch}`;
    // var options = {
    //   method: "POST",
    //   headers: {
    //     Accept: "application/json",
    //     "Content-Type": "application/json",
    //     Origin: "",
    //     Host: "andiamoplaces.com",
    //   },
    //   body: JSON.stringify({
    //     client_id: "REDACTED",
    //     grant_type: "client_credentials",
    //   }),
    // };

    // Plain fetch() with no timeout meant a single hung response left this
    // place's callback never firing at all — not an error, just silence —
    // which stalled TripAI's whole photo-fetch phase indefinitely on that
    // one place (real report: stuck at 3/31 with no further progress).
    // Matches the AbortController pattern already used elsewhere
    // (GooglePlaces.js's searchPlacesNewAPI). Found/prioritized 2026-09-05.
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);
    fetch(url, { signal: controller.signal })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        clearTimeout(timeoutId);
        //console.log("response", JSON.stringify(response));
        var images = GoogleSearch.processImages(response);
        callback(images, place_id);
      })

      .catch(function (error) {
        clearTimeout(timeoutId);
        console.log("Error in Google search", error);
        callback([], place_id);
      });
  };

  // Google indexes Wikimedia Commons pages too, so an image search can
  // return the exact same scanned book/PDF page a Commons text search would
  // (its OCR'd text matches the query) — this filter needs to catch it
  // independently of Wikimedia.js's own, since results reach here through a
  // completely different API. Added 2026-08-29 after a real example (a
  // 19th-century travel book's page scan) surfaced via this path even after
  // Wikimedia.js was filtered — see memory: project_cost_revenue_viability.
  static _isLikelyScannedDocument = (title, url) => {
    const lower = `${title || ""} ${url || ""}`.toLowerCase();
    return /\.(pdf|djvu)\b/.test(lower) || /(^|\/)page\d+-/.test(lower) || /\(ia_|%28ia_/.test(lower);
  };

  // `photo.link` is supposed to be the original, full-size image on its
  // source site — that's what gets used as Photo_m (the "large" field
  // notes/itineraries display). For some queries Google's own indexed
  // `link` resolves to one of ITS OWN low-res cache/thumbnail hosts instead
  // of the real original, producing a pixelated result even though nothing
  // here mixed up the thumbnail (image.thumbnailLink) and original (link)
  // fields — Google just didn't have a better one indexed. Skipping these
  // lets the existing fallback chain (Google -> Flickr) try for something
  // better rather than accepting a known-low-res image. Added 2026-08-29 —
  // see memory: project_cost_revenue_viability.
  static _isLowResGoogleHost = (url) => {
    const lower = (url || "").toLowerCase();
    return lower.includes("gstatic.com") || lower.includes("googleusercontent.com");
  };

  // Stock-photo libraries embed a visible watermark in every preview image
  // by design (that's what makes people pay for the unwatermarked original)
  // — unlike the scanned-doc/low-res cases above, there's no "better" version
  // to fall back to on the SAME result, so these have to be skipped outright
  // rather than just preferring a different field. Alamy confirmed via a
  // real report (2026-09-24); listing other common stock sites preemptively
  // since they'd fail the same way.
  static _isStockPhotoHost = (url) => {
    const lower = (url || "").toLowerCase();
    return (
      lower.includes("alamy.com") ||
      lower.includes("shutterstock.com") ||
      lower.includes("gettyimages.") ||
      lower.includes("istockphoto.com") ||
      lower.includes("dreamstime.com") ||
      lower.includes("123rf.com") ||
      lower.includes("depositphotos.com")
    );
  };

  static processImages = (response) => {
    let images = [];
    if (typeof response.items === "undefined") return [];
    //if (typeof response.query.pages === "undefined") return [];
    for (let i = 0; i < response.items.length; i++) {
      const photo = response.items[i];
      if (GoogleSearch._isLikelyScannedDocument(photo.title, photo.link)) continue;
      if (GoogleSearch._isLowResGoogleHost(photo.link)) continue;
      if (GoogleSearch._isStockPhotoHost(photo.link)) continue;
      images.push({
        name: photo.title,
        url: photo.image.thumbnailLink,
        url_m: photo.link,
        folder: "",
        id: "",
        date: "",
        type: 0,
      });
    }
    return images;
  };
}
